<template>
    <div class="location-list">
        <div class="location-search">
                <span class="location_form_label">Country:</span>
                <el-select v-model="countryId">
                    <el-option value="" label="All">All</el-option>
                    <el-option v-for="country in countryList" :key="country.id" :value="country.id" :label="country.nameEN">{{country.nameEN}}</el-option>
                    </el-select>
                <el-button type="primary" :loading="searchLoading"
                           @click="fetchLocationList"  class="subBtn">Filter</el-button>
            </div>
        <div class="location-add">
            <el-button type="primary"
                       @click="locationAdd()">Create</el-button>
        </div>
        <div class="location-content">
            <el-table :data="locationList" v-loading="searchLoading">
                <el-table-column prop="id"
                                 label="ID"></el-table-column>
                <el-table-column prop="name"
                                 label="Location Name"></el-table-column>
                <el-table-column prop="countryEN"
                                 label="Country"></el-table-column>
                <el-table-column prop="createTime"
                                 label="Created Time"></el-table-column>
                <el-table-column label="Operation">
                    <template slot-scope="scoped">
                        <div class="location-operation">
                            <!-- <router-link tag="span"
                                         :to="'/location/edit?id='+scoped.row.id">Edit</router-link> -->
                            <span @click="locationAdd(scoped.row.id)">Edit</span>
                            <span>|</span>
                            <span @click="delBlogById(scoped.row)">Delete</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                               @current-change="handleCurrentChange"
                               :current-page.sync="currentPage"
                               :page-size="pageSize"
                               layout=" prev, pager, next"
                               :total="total"
                                v-if="total !=0">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@api/cooperation'
export default {
    data () {
        return {
            locationList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            countryId:'',
            searchLoading:false,
            countryList:[]
        }
    },
    methods: {
        handleCurrentChange () {
            this.fetchLocationList();
        },
        async fetchLocationList () {
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize,
                params:{
                    countryId:this.countryId ? this.countryId : null
                }  
            }
            this.searchLoading = true;
            const res = await api.queryLocationPageList(params)
            this.searchLoading = false;
            if (res.success) {
                this.locationList = res.data.list
                this.currentPage = res.data.pageNum
                this.pageSize = res.data.pageSize
                this.total = res.data.total
            }else{
                this.$message({
                    type: 'error',
                    message: res.error && res.error.message ? res.error.message : 'Service exception!'
                });
            }
        },
        locationAdd (id) {
            if(id){
                this.$router.push({ path: '/location/edit', query: { id: id, pageNo: this.currentPage } })
            }else{
                this.$router.push('/location/edit')
            }
        },
        async delBlogById (row) {
            console.log(row)
            const ctx = await this.$confirm('This action will permanently delete the location to continue?', 'Tip', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).catch(err => {
                this.$message({
                    type: 'info',
                    message: 'Cancel delete'
                });
            })
            if (ctx == 'confirm') {
                let params = { id: row.id }
                const res = await api.delLocation(params)
                if (res.success == true) {
                    this.$message.success('Delete location successfully!')
                    this.fetchLocationList()
                }else{
                    this.$message({
                        type: 'error',
                        message: res.error && res.error.message ? res.error.message : 'Service exception!'
                    });
                }
            }
        },
        async fetchCountryList () {
            const res = await api.queryAllCountryList()
            if (res.success == true) {
                this.countryList = res.data
            }
        },
    },
    mounted () {
        if (this.$route.params && this.$route.params.pageNo) {
            this.currentPage = this.$route.params.pageNo
        }
        this.fetchCountryList();
        this.fetchLocationList();
    }
}
</script>
<style scoped>
.location-list {
    padding-top: 70px;
    margin-left: 270px;
}
.location-search{
    overflow: hidden;
}
.location-add {
    padding: 20px;
    border-bottom: 1px solid #e4e4e4;
}
.location-operation {
    display: flex;
    align-items: center;
    color: rgb(70, 162, 255);
}
.location-operation span {
    margin-right: 10px;
    cursor: pointer;
}
.pagination {
    margin-left: 250px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 20px;
}
.subBtn {
    border: none;
    color: #fff;
    width:130px;
    margin-left: 20px;
    background-color: #fe7b00;
}
.location_form_label {
        font-size: 16px;
        min-width: 120px;
        color: #606266;
        text-align: right;
        margin-right: 10px;
        margin-bottom: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/locationList.vue